/** Kolibri-only advisor-declined reason, stored in session metadata. */
export const KOLIBRI_DECLINED_ADVISOR_REASON_METADATA_KEY = 'kolibriDeclinedAdvisorReason';

export const KOLIBRI_DECLINED_ADVISOR_REASON_KEYS = {
  NOT_CONTACT_WITH_CUSTOMER: 'NOT_CONTACT_WITH_CUSTOMER',
  TIME_CONSUMING_PROCESS: 'TIME_CONSUMING_PROCESS',
  BANKID_UNCERTAINTY: 'BANKID_UNCERTAINTY',
  WONT_SHARE_DOCUMENTS_OR_PRICES: 'WONT_SHARE_DOCUMENTS_OR_PRICES',
  TECHNICAL_ERROR_DOCUMENT_UPLOAD: 'TECHNICAL_ERROR_DOCUMENT_UPLOAD',
  TECHNICAL_ERROR_BANKID: 'TECHNICAL_ERROR_BANKID',
  PRICE_TOO_HIGH_OR_NOT_ENOUGH_TO_SAVE: 'PRICE_TOO_HIGH_OR_NOT_ENOUGH_TO_SAVE',
  MISSING_PRODUCTS: 'MISSING_PRODUCTS',
  NEGOTIATION_OR_SAVED_BY_OTHER_COMPANY: 'NEGOTIATION_OR_SAVED_BY_OTHER_COMPANY',
  KOLIBRI_UNCERTAINTY: 'KOLIBRI_UNCERTAINTY',
  OTHER: 'OTHER',
} as const;

export type KolibriDeclinedAdvisorReasonKey =
  typeof KOLIBRI_DECLINED_ADVISOR_REASON_KEYS[keyof typeof KOLIBRI_DECLINED_ADVISOR_REASON_KEYS];

export interface KolibriDeclinedAdvisorReasonMetadataValue {
  reasonKey: KolibriDeclinedAdvisorReasonKey;
  otherText?: string;
}

export const KOLIBRI_DECLINED_ADVISOR_REASON_KEY_LIST_1_TO_7: KolibriDeclinedAdvisorReasonKey[] = [
  KOLIBRI_DECLINED_ADVISOR_REASON_KEYS.NOT_CONTACT_WITH_CUSTOMER,
  KOLIBRI_DECLINED_ADVISOR_REASON_KEYS.TIME_CONSUMING_PROCESS,
  KOLIBRI_DECLINED_ADVISOR_REASON_KEYS.BANKID_UNCERTAINTY,
  KOLIBRI_DECLINED_ADVISOR_REASON_KEYS.WONT_SHARE_DOCUMENTS_OR_PRICES,
  KOLIBRI_DECLINED_ADVISOR_REASON_KEYS.TECHNICAL_ERROR_DOCUMENT_UPLOAD,
  KOLIBRI_DECLINED_ADVISOR_REASON_KEYS.TECHNICAL_ERROR_BANKID,
  KOLIBRI_DECLINED_ADVISOR_REASON_KEYS.OTHER,
];

export const KOLIBRI_DECLINED_ADVISOR_REASON_KEY_LIST_8_TO_10: KolibriDeclinedAdvisorReasonKey[] = [
  KOLIBRI_DECLINED_ADVISOR_REASON_KEYS.NOT_CONTACT_WITH_CUSTOMER,
  KOLIBRI_DECLINED_ADVISOR_REASON_KEYS.PRICE_TOO_HIGH_OR_NOT_ENOUGH_TO_SAVE,
  KOLIBRI_DECLINED_ADVISOR_REASON_KEYS.MISSING_PRODUCTS,
  KOLIBRI_DECLINED_ADVISOR_REASON_KEYS.NEGOTIATION_OR_SAVED_BY_OTHER_COMPANY,
  KOLIBRI_DECLINED_ADVISOR_REASON_KEYS.KOLIBRI_UNCERTAINTY,
  KOLIBRI_DECLINED_ADVISOR_REASON_KEYS.OTHER,
];

export const KOLIBRI_DECLINED_ADVISOR_REASON_STATUS_KEYS_1_TO_7 = [
  // 'INIT_SESSION',
  'LINK_CLICKED',
  'SELECT_FLOW',
  'VALIDATION_FAILED',
  'FAILED',
  'OFFER_MANUAL_REVIEW',
  'EDITED',
] as const;

export const KOLIBRI_DECLINED_ADVISOR_REASON_STATUS_KEYS_8_TO_10 = [
  'PENDING',
  'SENT_OFFER_REMINDER',
  'OFFER_PROVIDED',
] as const;
